/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowAngleUpLeftIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABEUlEQVR4nO2UQUpDQQyGp3t1pdALuC/uu9LFw75JUmGaVK9S915B2hv0BF0p7aZdthXrFRR04wGUPN/Is4JgzWykP4SBGfi/JEzi3L9VFsKBR5554mmed/ftzYkXQPKm4VHuT0OoJzEHS4iaA8qyMI0nafBdec43bteXzJFXmm0EVN82rsST3MTM1VDvIuB7AjL6NQBIBgqJ5uuASgtHQHLlLLQOMFdygEd5LSAAu2kAJA8KQDxvJAJwv2xTLwkAoHPy8ff5MVmbAPm2gBAPnXM1c0DrrHsIxC8RkmUXe+YQRG56lOdyip888mXe7hyFEHZMK/FxnfwUyJM/gXLkYyC51qX3OSfVtU4yNqtqK2ehd8bKte2mChchAAAAAElFTkSuQmCC)
 */
export const ArrowAngleUpLeftIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7.3 2.3a1 1 0 0 1 1.4 0l5 5a1 1 0 0 1-1.4 1.4L9 5.42V11a7 7 0 0 0 7 7h4a1 1 0 1 1 0 2h-4a9 9 0 0 1-9-9V5.41l-3.3 3.3a1 1 0 0 1-1.4-1.42l5-5Z"
        className={colorClass}
      />
    </svg>
  );
};
